import { useState, useEffect } from "react";
import axiosService from "../../utils/axios.service";

import {Row,Col,Container} from "react-bootstrap"
import styles from "../../styles/popupInfor.module.css"
import { HistoryExamination } from '../customer/HistoryExamination'
import { format } from 'date-fns'

const Examination = ({customer}) => {

  const [listExamination, setListExamination] = useState([])
  const [idExamination, setIdExamination] = useState(null)
  const [showDetail, setShowDetail] = useState(false)


  const openHistory = (id) => {
    setIdExamination(id)
    setShowDetail(true)
  }

  useEffect(() => {
    const fetchData = async () => {
      const res = await axiosService(`api/customer/count-examination/${customer?.id}`, "GET");
      if (res.data.code === 200) {
        setListExamination(res.data.data)
      }
    }
    fetchData()
  }, [customer?.id])
  return (
    <>
      {showDetail && <HistoryExamination
        examinationId={idExamination}
        customer={customer}
        overflowClose={true}
        onClose={() => setShowDetail(false)}
      />}
      <Container>
        {listExamination.length > 0 ?
          <Row>
            {listExamination.map((x,y) => {
              return (
                <Col xs={12} key={y}>
                  <div className="d-flex justify-content-between mg-10" onClick={() => openHistory(x.id)}>
                    <div className={styles.examinationDate}>{format(new Date(x.created_at), "yyyy-MM-dd")}</div>
                    <div className={styles.examinationName}>{x?.consultant?.name}</div>
                  </div>
              </Col>
              )
            })
          }
        </Row>
        : "Không có dữ liệu"}
      </Container>
    </>
  )
}
export default Examination